require('./bootstrap');

$(document).ready(function () {
    $(document).on('change', '.container-login .form-control', function () {
        const self = $(this)
        if (self.val()) {
            self.addClass('filled')
        } else {
            self.removeClass('filled')
        }
    });

    $(document).on('click', '.js_showHidePassword', function (e) {
        e.preventDefault();
        const self = $(this);
        const icon = $('.fas', self);
        self.toggleClass('show');
        if (self.hasClass('show')) {
            self.attr('data-original-title', 'Esconder senha');
            icon.removeClass('fa-eye').addClass('fa-eye-slash')
            $('#password').attr('type', 'text');
        } else {
            self.attr('data-original-title', 'Exibir senha');
            icon.removeClass('fa-eye-slash').addClass('fa-eye')
            $('#password').attr('type', 'password');
        }
        self.blur()
    });

    $('[data-toggle="tooltip"]').tooltip();
    $('.container-login .form-control').trigger('change');
});
